<form class="auth-forgot-password-form mt-2" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmitForgot()">
  <div class="d-flex justify-content-between align-items-center mb-2">
    <ng-container *ngIf="!newPasswords">
      <p (click)="back.emit()" class="text-center mb-0 cursor-pointer">
        <i class="fa fa-chevron-left mr-1 text-muted" aria-hidden="true"></i>
        <span class="text-black">Back to Login</span>
      </p>
    </ng-container>
    <button type="button" (click)="launchHelpModal()" class="btn btn-sm text-black font-weight-bolder ml-auto" style="border: 1px solid #DDDEDD; background: #FCFCFC">
      Need Help <img src="assets/img/help.svg" style="height: 22px;" alt="">
    </button>
  </div>

  <div *ngIf="phoneNumberConfirmation && !resetCodeGenerated && !newPasswords">
    <h4 class="text-header">Reset Password</h4>
    <p class="text-black text-paragraph">We will send you a verification code to your phone number to allow you to update your password.</p>
  </div>

  <ngb-alert [type]="'info'" [dismissible]="false" *ngIf="
      proceedResetPassword &&
      !(error?.title || error?.body) &&
      !resetCodeGenerated &&
      !newPasswords
    ">
    <div class="alert-body">
      {{ resetCodeHint }}
    </div>
  </ngb-alert>

  <!-- send code form -->
  <div class="form-group" *ngIf="phoneNumberConfirmation && !newPasswords && !resetCodeGenerated">
    <label class="form-label mb-0" for="forgot-password-phone-number">Phone Number</label>
    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text student-phone-prefix">
          <img [src]="flagImageUrl" alt="Kenya Flag"> +254
        </span>
      </div>
      <input
        class="form-control"
        type="text"
        formControlName="phoneNumber"
        aria-describedby="forgot-password-phone-number"
        autofocus=""
        tabindex="1"
        [readonly]="phoneNumberReadonly"
        [ngClass]="{'is-invalid': f_submitted && ff.phoneNumber.errors}" />
    </div>

    <div *ngIf="f_submitted && ff.phoneNumber.errors" class="invalid-feedback">
      <div *ngIf="ff.phoneNumber.errors.required">
        Phone Number is required
      </div>
    </div>
  </div>

  <button [disabled]="loading" class="btn btn-primary btn-block" tabindex="2" rippleEffect
    *ngIf="!resetCodeGenerated && !newPasswords">
    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
    Send Code
  </button>

  <!-- OTP form -->
  <div *ngIf="resetCodeGenerated">
    <h4 class="text-header">Reset Password</h4>
    <p class="text-black text-paragraph">Enter the verification code sent to your number to update your password.</p>

    <app-otp-input
      #otpInputRef
      [invalid]="otpInvalid"
      [errorMessage]="otpErrorMessage"
      (valueChange)="currentOtpCode = $event">
    </app-otp-input>

    <button type="button" (click)="verifyOtp()" [disabled]="loading || currentOtpCode.length < 6"
      class="btn btn-primary btn-block" tabindex="2" rippleEffect *ngIf="resetCodeGenerated">
      <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
      Verify Phone Number
    </button>

    <div class="text-center mt-3" *ngIf="resetCodeGenerated">
      <p class="text-black">Didn't get a code?</p>
      <p *ngIf="!canResend" class="text-muted">Resend - {{ formattedCountdown }}</p>
      <p *ngIf="canResend" (click)="resendCode()" style="cursor: pointer;" class="text-primary font-weight-bolder">Resend Code</p>
    </div>
  </div>

  <!-- update password -->
  <div class="form-group" *ngIf="newPasswords">
    <h4 class="text-header">Update Password</h4>
    <p class="text-black text-paragraph">Enter and confirm your new password</p>

    <ngb-alert [type]="'success'" [dismissible]="false" *ngIf="passwordUpdatedSuccess">
      <div class="alert-body d-flex align-items-center gap-2 p-1">
        <img [src]="successTick" alt="success-icon">
        <div>
          <b>Your password has been updated successfully.Directing you to the Log in page shortly</b>
        </div>
      </div>
    </ngb-alert>

    <div class="form-group" *ngIf="newPasswords">
      <label for="register-password" class="form-label">New password</label>
      <div class="input-group input-group-merge form-password-toggle">
        <input [type]="passwordTextType ? 'text' : 'password'" formControlName="password"
          class="form-control form-control-merge" (input)="clearAlerts()" placeholder="New password" autocomplete="new-password"
          aria-describedby="register-password" tabindex="3" [ngClass]="{
            'is-invalid error': f_submitted && ff.password.errors
          }" />
        <div class="input-group-append">
          <span class="input-group-text cursor-pointer"><i class="feather font-small-4" [ngClass]="{
                'icon-eye-off': passwordTextType,
                'icon-eye': !passwordTextType
              }" (click)="togglePasswordTextType()"></i></span>
        </div>
      </div>
    </div>
    <div *ngIf="f_submitted && ff.password.errors" class="invalid-feedback" [ngClass]="{
          'd-block': f_submitted && ff.password.errors
        }">
      <div *ngIf="ff.password.errors.required">
        Password is required
      </div>
    </div>
  </div>

  <div class="form-group" *ngIf="newPasswords">
    <label for="register-confirmPassword" class="form-label">Confirm new password</label>
    <div class="input-group input-group-merge form-password-toggle">
      <input [type]="passwordTextType2 ? 'text' : 'password'" formControlName="confirmPassword"
        class="form-control form-control-merge" placeholder="Confirm password"
        aria-describedby="register-confirmPassword" tabindex="3" [ngClass]="{
          'is-invalid error': f_submitted && ff.confirmPassword.errors
        }" />
      <div class="input-group-append">
        <span class="input-group-text cursor-pointer">
          <i class="feather font-small-4" [ngClass]="{
              'icon-eye-off': passwordTextType2,
              'icon-eye': !passwordTextType2
            }" (click)="togglePasswordTextType2()"></i>
        </span>
      </div>
    </div>
    <div *ngIf="passwordSubmitted && ff.confirmPassword.errors" class="invalid-feedback" [ngClass]="{
          'd-block': passwordSubmitted && ff.confirmPassword.errors
        }">
      <div *ngIf="ff.confirmPassword.errors.required">Password required</div>
      <div *ngIf="ff.password.value != ff.confirmPassword.value">Password does not match</div>
    </div>
    <div *ngIf="passwordSubmitted && ff.password.value !== ff.confirmPassword.value"
      class="invalid-feedback" [ngClass]="{
      'd-block': passwordSubmitted && ff.password.value !== ff.confirmPassword.value
    }">
      <div>Password does not match</div>
    </div>
  </div>

  <div *ngIf="error?.body" class="alert alert-danger mt-2 p-1">
    {{ error.body }}
  </div>

  <button type="button" (click)="changePassword()" [disabled]="loading"
    class="btn btn-primary btn-block" tabindex="2" rippleEffect *ngIf="newPasswords">
    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
    {{ loading ? 'Updating password...' : 'Update Password' }}
  </button>
</form>